/**
 * 设置返回按钮动作层级
 * 目前适用于随手记
 */
import useragent from '@common/useragent'
import { call, uriSuishouji, uriSuiguanjia } from './bridge'

export default (level) => {
  if (useragent.isSuishouji && !isNaN(level)) {
    call(uriSuishouji('getBackClose', {
      isOpenBackClose: level
    }))
    // IOS客户端需要以下代码支持
    window.getBackClose = level
  } else if (useragent.isSuiguanjia) {
    const uri = uriSuiguanjia('sgj://app/webview/getBackClose', {
      isOpenBackClose: level,
    })
    call(uri)
    window.getBackClose = level
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/getBackClose.js